import React from 'react'

import Image from 'src/comps/Image'
import type { ImageApiObject } from 'src/types/image'
import Pill from 'src/comps/Atom/Pill'

import { getResponsiveImgProps } from '../utils'
import { thumbnailImageSizes } from '../constants'

import styles from './styles.module.css'
import { useS4LContext } from '@s4l/react-context'

interface IShowMoreThumbnailProps {
  handleClick: () => void
  image: ImageApiObject
  photosCount: number
}

export function ShowMoreThumbnail(props: Readonly<IShowMoreThumbnailProps>) {
  const { handleClick, image, photosCount } = props
  const { i18n } = useS4LContext()

  return (
    <button className={styles.thumbnailButtonBase} type="button" onClick={handleClick}>
      <Image alt="thumbnail" {...getResponsiveImgProps(image, thumbnailImageSizes)} />
      <Pill label={`${i18n.formatMessage({ id: 'image.gallery-all-photos' })} (${photosCount})`} />
    </button>
  )
}
